import type { LocalStorageKey } from '@/modules/common/enums/local-storage-key.enum.ts';

/** @deprecated: Используйте useLocalStorage из пакета @vueuse/core */
export class LocalStorageService {
  static setString<T extends string>(key: LocalStorageKey, value: T) {
    localStorage.setItem(key, value);
  }

  static getString<T extends string>(key: LocalStorageKey): T | null {
    return localStorage.getItem(key) as T | null;
  }
}
